<template>
    <section id="pricing" class="section price-plan-area">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-12 col-md-10 col-lg-6">
                    <!-- Section Heading -->
                    <div class="section-heading text-center">
                        <span class="pricing-kicker">{{ $t('pricing.kicker') }}</span>
                        <h2 class="text-capitalize">{{ $t('pricing.sectionTitle') }}</h2>
                        <p class="mt-4" v-html="$t('pricing.sectionDesc')"></p>
                    </div>
                </div>
            </div>
            <div class="row justify-content-center">
                <div class="price-plan-wrapper col-12">
                    <div class="single-price-plan">
                        <div class="price-header d-flex justify-content-between px-3 flex-column">
                            <h4 class="plan-title text-uppercase">
                                {{ $t('pricing.starterPlan.name') }}
                            </h4>
                            <div class="plan-cost">
                                <span class="plan-price">{{ $t('pricing.starterPlan.price') }}</span>
                            </div>
                        </div>
                        <div class="container">
                            <div>{{ $t('pricing.starterPlan.desc') }}</div>
                            <ul class="list-style-disc">
                                <li v-for="(feature, index) in $t('pricing.starterPlan.features')" :key="index">{{ feature }}</li>
                            </ul>
                        </div>
                        <div class="plan-select">
                            <a class="btn plan-btn" href="/#home">{{ $t('pricing.starterPlan.cta') }}</a>
                        </div>
                    </div>
                    <div class="single-price-plan featured">
                        <div class="popular-badge">{{ $t('pricing.mostPopular') }}</div>
                        <div class="price-header d-flex justify-content-between px-3 flex-column">
                            <h4 class="plan-title text-uppercase">
                                {{ $t('pricing.proPlan.name') }}
                            </h4>
                            <div class="plan-cost">
                                <span class="plan-price">{{ $t('pricing.proPlan.price') }}</span>
                                <span class="plan-type text-uppercase">{{ $t('pricing.proPlan.period') }}</span>
                            </div>
                        </div>
                        <div class="container">
                            <div>{{ $t('pricing.proPlan.desc') }}</div>
                            <ul class="list-style-disc">
                                <li v-for="(feature, index) in $t('pricing.proPlan.features')" :key="index">{{ feature }}</li>
                            </ul>
                        </div>
                        <div class="plan-select">
                            <a class="btn plan-btn plan-btn-light" href="/#home">{{ $t('pricing.proPlan.cta') }}</a>
                        </div>
                    </div>
                    <div class="single-price-plan">
                        <div class="price-header d-flex justify-content-between px-3 flex-column">
                            <h4 class="plan-title text-uppercase">
                                {{ $t('pricing.scalePlan.name') }}
                            </h4>
                            <div class="plan-cost">
                                <span class="plan-price">{{ $t('pricing.scalePlan.price') }}</span>
                                <span class="plan-type text-uppercase">{{ $t('pricing.scalePlan.period') }}</span>
                            </div>
                        </div>
                        <div class="container">
                            <div>{{ $t('pricing.scalePlan.desc') }}</div>
                            <ul class="list-style-disc">
                                <li v-for="(feature, index) in $t('pricing.scalePlan.features')" :key="index">{{ feature }}</li>
                            </ul>
                        </div>
                        <div class="plan-select">
                            <a class="btn plan-btn" href="/#home">{{ $t('pricing.scalePlan.cta') }}</a>
                        </div>
                    </div>
                    <div class="single-price-plan">
                        <div class="price-header d-flex justify-content-between px-3 flex-column">
                            <h4 class="plan-title text-uppercase">
                                {{ $t('pricing.enterprisePlan.name') }}
                            </h4>
                            <div class="plan-cost">
                                <span class="plan-price">{{ $t('pricing.enterprisePlan.price') }}</span>
                                <span class="plan-type text-uppercase">{{ $t('pricing.enterprisePlan.period') }}</span>
                            </div>
                        </div>
                        <div class="container">
                            <div>{{ $t('pricing.enterprisePlan.desc') }}</div>
                            <ul class="list-style-disc">
                                <li v-for="(feature, index) in $t('pricing.enterprisePlan.features')" :key="index">{{ feature }}</li>
                            </ul>
                        </div>
                        <div class="plan-select">
                            <a class="btn plan-btn" href="/contact">{{ $t('pricing.enterprisePlan.cta') }}</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {

}
</script>

<style scoped>
.price-plan-area {
    background: #f5f8fd;
    padding: 92px 0 110px;
}

.section-heading {
    margin-bottom: 58px;
}

.pricing-kicker {
    color: var(--blue);
    display: block;
    font-size: 12px;
    font-weight: 800;
    letter-spacing: 0;
    margin-bottom: 14px;
    text-transform: uppercase;
}

.section-heading h2 {
    color: #111827;
    font-size: 42px;
    font-weight: 800;
}

.section-heading h2::after {
    display: none;
}

.section-heading p {
    color: #647084;
    font-size: 15px;
}

.price-plan-wrapper {
    align-items: stretch;
    display: grid;
    gap: 24px;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    padding-top: 18px;
}

.single-price-plan {
    background: #fff;
    border: 0;
    border-radius: 8px;
    box-shadow: 0 20px 60px rgba(14, 47, 108, 0.08);
    display: flex;
    flex-direction: column;
    float: none;
    height: 100%;
    overflow: visible;
    padding: 30px 24px;
    position: relative;
    width: auto;
}

.single-price-plan:first-of-type,
.single-price-plan:last-of-type {
    border-radius: 8px;
}

.single-price-plan.featured {
    background: var(--blue1);
    box-shadow: 0 24px 70px rgba(7, 57, 234, 0.28);
}

.popular-badge {
    background: #7cb342;
    border-radius: 100px;
    color: #fff;
    font-size: 12px;
    font-weight: 800;
    left: 50%;
    letter-spacing: 0;
    line-height: 1;
    padding: 10px 18px;
    position: absolute;
    text-align: center;
    top: 0;
    transform: translate(-50%, -50%);
    white-space: nowrap;
}

.single-price-plan .price-header {
    background: transparent;
    line-height: 1.2;
    min-height: 82px;
    padding: 0 !important;
}

.single-price-plan .price-header::after {
    display: none;
}

.plan-title {
    color: var(--blue);
    font-size: 13px;
    font-weight: 800;
    letter-spacing: 0;
}

.plan-cost {
    color: #111827;
    text-align: left;
    margin-top: 4px;
}

.plan-cost .plan-price {
    font-size: 34px;
    font-weight: 800;
}

.plan-cost .plan-type {
    font-size: 12px;
}

.single-price-plan .container {
    display: flex;
    flex: 1;
    flex-direction: column;
    padding: 0;
}

.single-price-plan .container > div {
    color: #94a3b8;
    font-size: 14px;
    line-height: 1.6;
}

.single-price-plan ul {
    flex: 1;
    margin-top: 20px;
    padding-left: 0;
}

.single-price-plan li {
    color: #4b5870;
    font-size: 14px;
    line-height: 1.5;
    list-style: none;
    margin: 12px 0;
    padding-left: 22px;
    position: relative;
}

.single-price-plan li::before {
    color: var(--blue3);
    content: "✓";
    font-weight: 800;
    left: 0;
    position: absolute;
}

.plan-select {
    border-top: 0;
    margin-top: auto;
    padding: 24px 0 0;
}

.plan-btn {
    background: var(--blue3);
    border-radius: 100px;
    display: block;
    font-size: 13px;
    font-weight: 800;
    padding: 14px 16px;
    width: 100%;
}

.featured .plan-title,
.featured .plan-cost,
.featured li {
    color: #fff;
}

.featured li::before {
    color: #b7ff70;
}

.featured .plan-btn-light {
    background: #fff;
    color: var(--blue);
}

@media (max-width: 991px) {
    .price-plan-wrapper {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }

}

@media (max-width: 575px) {
    .price-plan-wrapper {
        grid-template-columns: 1fr;
    }
}
</style>
